import React from 'react';

// TODO:
export default class TopHostQuestions extends React.Component {
  render() {
    return <div className="top-host-questions">TopHostQuestions</div>;
  }
}

TopHostQuestions.propTypes = {};

TopHostQuestions.defaultProps = {};
